// extracted by mini-css-extract-plugin
export var active = "_tr-1";
export var circle = "_tr-0";
export var completed = "_tr-2";
export var connector = "_tr-4";
export var connectorCompleted = "_tr-7";
export var connectorSpacer = "_tr-5";
export var iconStrokeOverride = "_tr-8";
export var labelContainer = "_tr-6";
export var pending = "_tr-3";